package tta.destinigo.talktoastro.core.navigation_decompose.root_component

import com.arkivanov.decompose.router.slot.ChildSlot
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.value.Value
import com.arkivanov.essenty.backhandler.BackHandlerOwner
import tta.destinigo.talktoastro.bottom_navigation.BottomNavigationComponent
import tta.destinigo.talktoastro.feature_article.persentation.post_page.ArticleComponent
import tta.destinigo.talktoastro.feature_article.persentation.posts_page.ArticlesComponent
import tta.destinigo.talktoastro.feature_authentication.persentation.login_page.LoginPageComponent
import tta.destinigo.talktoastro.feature_authentication.persentation.otp_validation_page.OtpValidationComponent
import tta.destinigo.talktoastro.feature_authentication.persentation.register_page.RegisterComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info.CallConsultationComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_consultation_options.CallConsultationOptionsComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_success_page.CallSuccessComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.QueueComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet.QueueStatusComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.voip_call_page.VoipCallComponent
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_bottom_sheet_info.ChatConsultationComponent
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_host.decompose.HostDefaultComponent
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_queue_bottom_sheet_info.ChatQueueConsultationComponent
import tta.destinigo.talktoastro.feature_course.persentation.course_page.CourseComponent
import tta.destinigo.talktoastro.feature_course.persentation.course_preview_video.CourseVedioComponent
import tta.destinigo.talktoastro.feature_course.persentation.course_video.CourseLessonsComponent
import tta.destinigo.talktoastro.feature_course.persentation.courses_page.CoursesComponent
import tta.destinigo.talktoastro.feature_custom_order.CustomOrderComponent
import tta.destinigo.talktoastro.feature_custom_order.persentation.custom_order_details.CustomOrderDetailsComponent
import tta.destinigo.talktoastro.feature_expert_details.persentation.expert_detail_page.ExpertDetailsPageComponent
import tta.destinigo.talktoastro.feature_expert_listing.presentation.ExpertListPageComponent
import tta.destinigo.talktoastro.feature_expert_search.SearchScreenComponent
import tta.destinigo.talktoastro.feature_home.presentation.notificationsScreen.NotificationComponent
import tta.destinigo.talktoastro.feature_post.PostDetailsComponent
import tta.destinigo.talktoastro.feature_post.PostScreenComponent
import tta.destinigo.talktoastro.feature_profile.component.AboutUsComponent
import tta.destinigo.talktoastro.feature_profile.component.ChatConversationComponent
import tta.destinigo.talktoastro.feature_profile.component.ChatHistoryComponent
import tta.destinigo.talktoastro.feature_profile.component.ContactUsComponent
import tta.destinigo.talktoastro.feature_profile.component.EditProfileComponent
import tta.destinigo.talktoastro.feature_profile.component.MoreScreenTabComponent
import tta.destinigo.talktoastro.feature_profile.component.PrivacyPolicyComponent
import tta.destinigo.talktoastro.feature_profile.component.TermsAndConditionsComponent
import tta.destinigo.talktoastro.feature_profile.favourites.persentation.FavoriteScreenComponent
import tta.destinigo.talktoastro.feature_profile.purchase_history.PurchaseHistoryComponent
import tta.destinigo.talktoastro.feature_profile.refer_and_earn.ReferAndEarnScreenComponent
import tta.destinigo.talktoastro.feature_profile.transaction_history.persentation.TransactionHistoryComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.razorpay_gateway_new.StartGatewayComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_checkout.RechargeCheckoutComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_failure.RechargeFailureComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_getway.PaymentGatewayComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_pack.ChoseRechargePackComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_payment_success.RechargeSuccessComponent
import tta.destinigo.talktoastro.shared.persentation.ExitConfirmationDialogComponent
import tta.destinigo.talktoastro.shared.persentation.dialog.NotificationPermissionComponent
import tta.destinigo.talktoastro.shared.persentation.image_viewer.ImageViewerComponent
import tta.destinigo.talktoastro.shared.persentation.login_dialog.LoginDialogComponent

interface RootComponent : BackHandlerOwner {

    val stack: Value<ChildStack<*, Child>>
    val dialog: Value<ChildSlot<*, DialogChild>>

    fun onBackClicked()
    fun selectTab(index: Int)
    fun onBackClicked(toIndex: Int)

    sealed class DialogChild{
        data class LoginChild(val component:LoginDialogComponent) : DialogChild()
        data class OtpValidationChild(val component: OtpValidationComponent) : DialogChild()
        data class RegistrationChild(val component: RegisterComponent) : DialogChild()
        data class QueueDialogChild(val component: QueueComponent): DialogChild()
        data class QueueStatusDialogChild(val component: QueueStatusComponent): DialogChild()
        data class ExitDialog(val component: ExitConfirmationDialogComponent): DialogChild()
        data class ChatDurationDialogChild(val component:ChatConsultationComponent):DialogChild()
        data class CallDurationDialogChild(val component:CallConsultationComponent):DialogChild()
        data class CallOptionDialogChild(val component:CallConsultationOptionsComponent):DialogChild()
        data class ChatQueueJoinDialog(val component:ChatQueueConsultationComponent):DialogChild()
        data class PermissionDialogChild(val component:NotificationPermissionComponent):DialogChild()
        data class ImageViewerDialogChild(val component: ImageViewerComponent):DialogChild()
    }

    sealed class Child {
        data class LoginPage(val component: LoginPageComponent) : Child()
        data class OtpValidationPage(val component: OtpValidationComponent) : Child()
        data class RegistrationPage(val component: RegisterComponent) : Child()
        data class ExpertListPage(val component: ExpertListPageComponent) : Child()
        data class ExpertDetailsPage(val component: ExpertDetailsPageComponent) : Child()
        data class ChoseRechargePage(val component: ChoseRechargePackComponent) : Child()
        data class MoreScreenTab(val component: MoreScreenTabComponent) : Child()
//        data class HomeScreenTab(val component: HomeScreenTabComponent) : Child()
       // data class MainScreen(val component: MainScreenComponent) : Child()
        data class PrivacyPolicyPage(val component: PrivacyPolicyComponent) : Child()
        data class TermsAndConditions(val component: TermsAndConditionsComponent) : Child()
        data class EditProfileScreen(val component: EditProfileComponent) : Child()

        //feature_winyway_wallet
        data class RechargeCheckout(val component: RechargeCheckoutComponent) : Child()
        data class PaymentGateway(val component: PaymentGatewayComponent) : Child()
        data class RechargeSuccess(val component: RechargeSuccessComponent) : Child()
        data class RechargeFailure(val component: RechargeFailureComponent) : Child()
        data class StartGatewayChild(val component: StartGatewayComponent) : Child()

        // feature_expert_search
        data class DisplaySearchExpertList(val component: SearchScreenComponent) : Child()

        data class ChatHostChild(
            val component: HostDefaultComponent
        ) : Child()

        data class CallConsultationOptions(
            val component: CallConsultationOptionsComponent
        ): Child()

        data class CallConsultationInfo(
            val component: CallConsultationComponent
        ): Child()

        data class CallPlaceSuccess(
            val component: CallSuccessComponent
        ): Child()

        data class CallWaitingSuccess(
            val component: CallSuccessComponent
        ): Child()
//        /*VoIP Call*/
        data class VoIPCall(
            val component: VoipCallComponent
        ): Child()

        //TransactionHistory
        data class TransactionHistory(val component: TransactionHistoryComponent): Child()

        // Chat History Screen
        data class ChatHistory(val component: ChatHistoryComponent, val expertDetailsPageComponent: ExpertDetailsPageComponent):
            Child()
        // Chat Conversation Screen
        data class ChatConversationScreen(val component: ChatConversationComponent): Child()
        // Article Detail Page
        data class ArticleDetailPage(val component: ArticleComponent): Child()
        // Article Host Page
        data class ArticleHostChild(val component: ArticlesComponent): Child()
        // Custom Order
        data class CustomOrderPage(val component: CustomOrderComponent) : Child()
        //  Custom Order Details
        data class CustomOrderDetails(val component: CustomOrderDetailsComponent): Child()
        // Courses
        data class CoursesPageChild(val component: CoursesComponent) : Child()
        data class CoursePageChild(val component: CourseComponent) : Child()
        // Purchase History
        data class PurchaseHistory(val component: PurchaseHistoryComponent): Child()
        // Refer and Earn
        data class ReferAndEarn(val component: ReferAndEarnScreenComponent): Child()

        //Post
        data class PostScreen(val component: PostScreenComponent): Child()
        data class PostDetailsScreenChild(val component: PostDetailsComponent): Child()
        data class FavoriteScreenChild(val component: FavoriteScreenComponent): Child()
        data class AboutUs(val component: AboutUsComponent): Child()
        data class ContactUs(val component: ContactUsComponent): Child()
        data class BottomNavigationChild(val component: BottomNavigationComponent): Child()
        data class  CourseVedio (val component: CourseVedioComponent):Child()
        data class  CourseLessonChild (val component: CourseLessonsComponent):Child()
        data class NotificationClid(val component: NotificationComponent): Child()

    }
}